module.exports = __webpack_public_path__ + "static/img/1.1122e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/1.png
// module id = hn+6
// module chunks = 1